<app-tags classes="tags_left" [tags$]="tags$" />
